let timer = null;
import { ref } from 'vue';
export const waitForLoad = ref(false);
export const loadNum = ref(0);
export function user_search(search_assets) {
  waitForLoad.value = true;
  loadNum.value = 80;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    search_assets();
    loadNum.value = 100;
    setTimeout(() => {
      waitForLoad.value = false;
      setTimeout(() => {
        loadNum.value = 0;
      }, 100);
    }, 100);
  }, 400);
}
